export default __webpack_public_path__ + "static/media/emoji_trainers.115b4956.svg";